import { setAllSkyImage } from "./allsky_images";
import { allowRefresh, createLoadingSpinner } from "../utils";

/**
 * Change entries in the overview panels of the "Current Status" page to loading spinners
 */
export function resetOverviewText() {
  const nodeIDs = [
    "ov-astro-sun-visibility",
    "ov-astro-moon-visibility",
    "ov-weather-temperature",
    "ov-weather-humidity",
    "ov-weather-windspeed",
    "ov-weather-rainfall",
    "ov-vis-clarity",
    "ov-vis-darkness",
    "ov-power-charge",
    "ov-power-status",
  ];

  for (let id of nodeIDs) {
    document.getElementById(id).replaceChildren(createLoadingSpinner());
  }
}

/**
 * Set the all-sky image to a loading screen
 */
export function resetAllSkyImage() {
  setAllSkyImage("/images/loading.png");
}

/**
 * Change the styling of the refresh button if refreshing is enabled
 * This is put on a timer by refresh.initializePage
 */
export function updateRefreshButtonState() {
  const button = document.getElementById("refresh-data-button");
  if (allowRefresh()) {
    button.removeAttribute("disabled");
  } else {
    button.setAttribute("disabled", true);
  }
}
